// /src/Settings/Settings.jsx

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getInitials, getAvatarColor } from "./profileUtils";
import { updateProfile, getPublicKey } from "../api";
import { jwtDecode } from "jwt-decode";

export default function Settings() {
  const [name, setName] = useState(localStorage.getItem("name") || "");
  const mobile = localStorage.getItem("mobile") || "";
  const [avatar, setAvatar] = useState(null);
  const [currentAvatar, setCurrentAvatar] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const decoded = jwtDecode(token);
          const res = await getPublicKey(decoded.mobile);
          if (res.data.avatar) {
            setCurrentAvatar(res.data.avatar);
          }
          if (res.data.name) {
            setName(res.data.name);
          }
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, []);

  const handleLogout = () => {
    // localStorage.clear();
    const identityPrivateKey = localStorage.getItem("identityPrivateKey");
    const identityPublicKey = localStorage.getItem("identityPublicKey");

    localStorage.clear();

    if (identityPrivateKey) {
      localStorage.setItem("identityPrivateKey", identityPrivateKey);
    }
    if (identityPublicKey) {
      localStorage.setItem("identityPublicKey", identityPublicKey);
    }

    window.dispatchEvent(new Event("storage"));
    navigate("/");
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) setAvatar(URL.createObjectURL(file));
  };

  const handleSave = async () => {
    try {
      let avatarData = null;
      if (avatar) {
        // Convert file to base64
        const response = await fetch(avatar);
        const blob = await response.blob();
        const reader = new FileReader();
        avatarData = await new Promise((resolve) => {
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }

      await updateProfile(name, avatarData);
      localStorage.setItem("name", name);
      // Dispatch event to refresh user list
      window.dispatchEvent(new Event("profileUpdated"));
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile. Please try again.");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 500 }}>
      <h3 className="mb-4 text-center">Settings</h3>

      {/* Profile */}
      <div className="mb-3 text-center">
        <label className="form-label">Profile</label>
        <div>
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              className="rounded-circle mb-2"
              style={{ width: 100, height: 100, objectFit: "cover" }}
            />
          ) : currentAvatar ? (
            <img
              src={currentAvatar}
              alt="Avatar"
              className="rounded-circle mb-2"
              style={{ width: 100, height: 100, objectFit: "cover" }}
            />
          ) : (
            <div
              className="rounded-circle text-white d-flex justify-content-center align-items-center mb-2"
              style={{
                width: 100,
                height: 100,
                fontSize: 40,
                backgroundColor: getAvatarColor(name),
              }}
            >
              {getInitials(name)}
            </div>
          )}
        </div>
        <input
          type="file"
          accept=".png,.jpg,.webp"
          className="form-control"
          onChange={handleAvatarChange}
        />
      </div>

      {/* Mobile */}
      <div className="mb-3">
        <label className="form-label">Mobile Number</label>
        <input type="text" className="form-control" value={mobile} disabled />
      </div>

      {/* Name */}
      <div className="mb-3">
        <label className="form-label">Your Name</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      {/* Actions */}
      <div className="d-flex justify-content-between">
        <button className="btn btn-primary" onClick={handleSave}>
          Save Changes
        </button>
        <button className="btn btn-danger" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
